import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import DomPurify from 'dompurify';
import { ButtonClassNames } from '../../../../models/Common';
import { CustomMUIButton } from '../../buttons/CustomMUIButton';
import { AnimatedIcon } from '../../AnimatedIcon';
import ErrorIconLight from '../../../../assets/images/lottieIcons/error/error.light.json';
import ErrorIconDark from '../../../../assets/images/lottieIcons/error/error.dark.json';

interface IConfirmationsLimit {
  notice: string;
  handleClose: () => void;
}

export const ConfirmationsLimit: FC<IConfirmationsLimit> = ({ notice, handleClose }) => {
  const { t } = useTranslation();
  const sanitizer = DomPurify.sanitize;

  return (
    <div className="modals">
      <div className="modals__header modals__header__top-up">
        <AnimatedIcon lightIcon={ErrorIconLight} darkIcon={ErrorIconDark} className="icon-limit" />
        <article className="modals__header__title">{t('multiAccount.confirmationsLimit')}</article>
        <p
          className="modals__header__description"
          dangerouslySetInnerHTML={{
            __html: sanitizer(notice.replace(/(\d{2}:\d{2})/, '<strong>$1</strong>')),
          }}
        />
      </div>
      <div className="modals__btn-group">
        <CustomMUIButton
          label={t('buttons.close')}
          handleClick={handleClose}
          className={ButtonClassNames.PrimaryFulfilled}
          isBold
        />
      </div>
    </div>
  );
};
